// gloss
export const IDP_RETRY_KEY = 'idp_initiated_retry';

export type CallbackDecision = 'sdk-owned' | 'idp-initiated-retry' | 'idp-initiated-exhausted' | 'not-callback';

type ClassifyArgs = {
  search: string;
  isAuthenticated: boolean;
  isSSOBrand: boolean;
  brandName: string;
  alreadyRetried: boolean;
};

// gloss
export const classifyCallback = ({
  search,
  isAuthenticated,
  isSSOBrand,
  brandName,
  alreadyRetried,
}: ClassifyArgs): CallbackDecision => {
  const params = new URLSearchParams(search);
  if (!params.has('code')) return 'not-callback';

  if (isAuthenticated) return 'sdk-owned';

  // why: Cohesity's IdP always emits stateless SAML; discriminator must stay
  // why: isAuthenticated===false, not literal `state` inspection.
  if (!isSSOBrand || !brandName) return 'not-callback';

  // why: stop after one retry on a stateless code — retrying again would create an infinite SSO
  // why: redirect loop.
  if (alreadyRetried) return 'idp-initiated-exhausted';
  return 'idp-initiated-retry';
};
